import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {ApolloQueryObservable} from "apollo-angular";
import {WithdrawalService} from "../../services/withdrawal.service";
import {Withdrawal} from "../../model/withdrawal";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {Page} from '../../../shared/view-model/core/page.model';
import {SortInfo} from '../../../shared/view-model/core/sort.model';
import {FetchWithdrawlsQuery} from '../../../shared/graphql/graphql.types';
import {FormBuilder, FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {WithdrawalLogComponent} from '../../withdrawal-log/withdrawal-log.component';

@Component({
  selector: 'vb-withdrawal-log-view',
  templateUrl: './withdrawal-log-view.component.html',
  styleUrls: ['./withdrawal-log-view.component.css']
})
export class WithdrawalLogViewComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit {

  @ViewChild('logView')
  logView: WithdrawalLogComponent;

  searchTerm: FormControl;

  page = new Page();
  sort = new SortInfo();

  private withdrawals$: ApolloQueryObservable<FetchWithdrawlsQuery>;
  withdrawals: Withdrawal[] = [];

  constructor(sessionActions: SessionActions,
              private withdrawalService: WithdrawalService, cd: ChangeDetectorRef,
              private fb: FormBuilder) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();

    this.isLoading = true;

    this.searchTerm = this.fb.control(null);

    this.withdrawals$ = this.withdrawalService.getWithdrawals(null, null, this.page.size, this.page.pageNumber);
    this.addComponentData(this.withdrawals$);

    this.dataSubscriptions.push(this.withdrawals$.subscribe(res => {
      this.isLoading = res.loading;
      this.page.totalElements = res.data.fetchWithdrawals.total_items;
      this.page.totalPages = res.data.fetchWithdrawals.total_pages;
      this.withdrawals = res.data.fetchWithdrawals.items;
    }));

  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.addSubscription(this.searchTerm.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(500)
      ).subscribe(searchString => {
        this.logView.table.resetToFirstPage(); // Resets table to first page and automatically triggers a reload of the data because of the onPageChanged event
      })
    );
  }

  onPageChanged(pageInfo: Page) {
    if (this.withdrawals$) {
      this.withdrawals$.setVariables({
        limit: pageInfo.size,
        offset: pageInfo.pageNumber,
        queryString: this.searchTerm.value,
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/withdrawal/withdrawal-log-view/withdrawal-log-view.component.ts